const URL_BASE = 'https://alttab.ar/publicidad/lt10/lt10-ms/public';
const PUBLIC_FOLDER = '/public';

export const environment = {
  context: '',
  servicedebug: true,
  production: false,
  redirectWhenResponseNotSuccess: false,
  REGISTROS_PER_PAGE: 30,
  REGISTROS_PER_PAGE_AUTOCOMPLETE: 150,
  REGISTROS_PER_PAGE_OPTIONS: [10, 20, 30, 50, 100],
  API_URI_BACKEND: '/api',
  API_BASE_URL: URL_BASE,
  URL_API: `${URL_BASE}/index.php/api`,
  URL_RESOURCES: `${URL_BASE}/public`,
  URL_RESOURCES_IMAGE: `${URL_BASE}/${PUBLIC_FOLDER}`,
  URL_FILE_MANAGER: `${URL_BASE}/fileManager/staticfile?path=`,
  PATH_IMAGES: 'assets/images',
  pricingDebug: false,
  
  // Roles del sistema
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_USER: 'ROLE_USER',
  ROLE_VIEWER: 'ROLE_VIEWER',
  ROLES_ARRAY: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_VIEWER'],
  
  // Jerarquía de roles
  ROLES_JERARQUIA: {
    ROLE_SUPER_ADMIN: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_VIEWER'],
    ROLE_ADMIN: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_VIEWER'],
    ROLE_USER: ['ROLE_USER', 'ROLE_VIEWER'],
    ROLE_VIEWER: ['ROLE_VIEWER']
  },
  
  // Información del sistema
  ATRIBUTE_ENTE: 'LT10',
  ATRIBUTE_SISTEMA_NAME: 'Sistema LT10',
  AUTOR_NAME: 'Andres Brusutti',
  KEYWORDS: 'Sistema de Gestión LT10',
  
  // Seguridad
  BADWORDS: ['SELECT', 'INSERT', 'FROM', 'UPDATE', 'DELETE', 'SQLSTATE'],
  extensionAvailableForUpload: ['png', 'jpg', 'jpeg', 'doc', 'bmp', 'docx', 'xls', 'xlsx', 'rar', 'zip', 'pdf', 'ppt', 'pptx', 'odt', 'ods', 'txt']
};
